import {
    getPaymentIframeElement,
    getPaymentIframeHandshakeEventName,
} from "../../utility";

const paymentIframeHandshakeEvent = getPaymentIframeHandshakeEventName();

/**
 *
 * @description Makes it easy for us to update how long we want to poll the
 * PCI Payment Iframe in case we ever want to change this in the future.
 * @param {number} secondsToPoll
 * @param {number} pollingInterval
 * @returns {number}
 */
export const getMaxNumberOfHandshakeAttempts = (
    secondsToPoll,
    pollingInterval,
) => {
    const millisecondsToPoll = secondsToPoll * 1000;
    const maxNumberOfHandshakeAttempts = Math.floor(
        millisecondsToPoll / pollingInterval,
    );

    return maxNumberOfHandshakeAttempts;
};

/**
 *
 * @description Sends the initial handshake whose response we will await before
 * displaying the content of the payment iframe.
 * @param {string} urlOfPaymentIframe
 * @returns {void}
 */
export const sendHandshakeToPaymentIframe = (urlOfPaymentIframe) => {
    const paymentIframe = getPaymentIframeElement();
    const elementToSendPostMessageTo = paymentIframe?.contentWindow;

    if (paymentIframe && !!elementToSendPostMessageTo) {
        const event = paymentIframeHandshakeEvent;
        const message = {
            event,
        };
        const targetOrigin = urlOfPaymentIframe;

        elementToSendPostMessageTo.postMessage(
            JSON.stringify(message),
            targetOrigin,
        );
    }
};
